function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M339.063,60.817H228.938c-7.628,0-13.834,6.206-13.834,13.834v99.816l0,0c-4.47-2.616-9.666-4.123-15.208-4.123 c-16.658,0-30.21,13.552-30.21,30.209s13.552,30.209,30.21,30.209c16.657,0,30.209-13.552,30.209-30.209v-86.423h107.95v60.338 c-4.47-2.616-9.666-4.123-15.208-4.123c-16.657,0-30.209,13.552-30.209,30.209s13.552,30.209,30.209,30.209 s30.209-13.552,30.209-30.209V74.81l0,0C353.056,67.093,346.778,60.817,339.063,60.817z M199.896,215.759 c-8.387,0-15.209-6.822-15.209-15.208s6.822-15.208,15.209-15.208c8.385,0,15.208,6.822,15.208,15.208 S208.282,215.759,199.896,215.759z M322.848,215.759c-8.385,0-15.208-6.822-15.208-15.208s6.822-15.208,15.208-15.208 c8.386,0,15.208,6.822,15.208,15.208S331.232,215.759,322.848,215.759z M338.055,99.127H230.105V75.818h107.95v23.309H338.055z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M254.433,317.548h-97.159c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h97.159c4.143,0,7.5-3.358,7.5-7.5 S258.577,317.548,254.433,317.548z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M254.433,355.124h-97.159c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h97.159c4.143,0,7.5-3.358,7.5-7.5 C261.934,358.482,258.577,355.124,254.433,355.124z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M254.433,392.698h-97.159c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h97.159c4.143,0,7.5-3.358,7.5-7.5 S258.577,392.698,254.433,392.698z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M387.082,317.548h-97.16c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h97.16c4.143,0,7.5-3.358,7.5-7.5 S391.226,317.548,387.082,317.548z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M329.632,274.728c0-4.142-3.357-7.5-7.5-7.5h-97.16c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h97.16 C326.274,282.228,329.632,278.87,329.632,274.728z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M387.082,355.124h-97.16c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h97.16c4.143,0,7.5-3.358,7.5-7.5 C394.583,358.482,391.226,355.124,387.082,355.124z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M254.433,430.273h-97.159c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h97.159c4.143,0,7.5-3.358,7.5-7.5 C261.934,433.631,258.577,430.273,254.433,430.273z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M444.04,0H289.236c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5H444.04c4.444,0,8.061,3.616,8.061,8.06v215.437 c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5V23.061C467.102,10.346,456.757,0,444.04,0z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M459.602,266c-4.143,0-7.5,3.358-7.5,7.5v119.197c-4.693,0-151.358,0-162.179,0c-4.143,0-7.5,3.358-7.5,7.5 s3.357,7.5,7.5,7.5h59.335c-0.939,2.51-1.457,5.226-1.457,8.06v14.514h-57.878c-4.143,0-7.5,3.358-7.5,7.5 c0,4.142,3.357,7.5,7.5,7.5H347.8v51.725H122.344c-4.444,0-8.061-3.616-8.061-8.06V23.061c0-4.444,3.616-8.06,8.061-8.06h131.889 c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H67.959l0,0C55.243,0,44.898,10.346,44.898,23.061v465.877 c0,12.716,10.346,23.061,23.061,23.061l0,0h287.341c0.041,0,0.08-0.005,0.12-0.006c2.005-0.033,3.861-0.87,5.184-2.191 l104.301-104.3c1.333-1.332,2.196-3.245,2.196-5.303V273.502C467.102,269.358,463.744,266,459.602,266z M100.736,496.999H67.959 c-4.444,0-8.06-3.616-8.06-8.06V23.061c0-4.444,3.615-8.06,8.06-8.06h32.777c-0.901,2.496-1.453,5.115-1.453,8.06v465.877 C99.283,491.82,99.815,494.448,100.736,496.999z M362.801,486.391v-70.632c0-4.444,3.615-8.06,8.06-8.06c7.587,0,62.354,0,70.633,0 C433.153,416.039,371.141,478.051,362.801,486.391z"
});

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EADCD6"
    },
    d: "M107.736,489.624V23.576c0-8.598,6.969-15.567,15.567-15.567H68.896 c-8.598,0-15.567,6.969-15.567,15.567v466.047c0,8.598,6.969,15.567,15.567,15.567h54.405 C114.704,505.191,107.736,498.221,107.736,489.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDCDC7"
    },
    d: "M73.331,489.624V23.576c0-8.598,6.969-15.567,15.566-15.567H68.896 c-8.598,0-15.566,6.969-15.566,15.567v466.047c0,8.598,6.969,15.567,15.566,15.567h20.001 C80.301,505.191,73.331,498.221,73.331,489.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EADCD6"
    },
    d: "M444.015,8.01H122.202c-8.598,0-15.567,6.969-15.567,15.567v466.047 c0,8.598,6.969,15.567,15.567,15.567h233.041l104.339-104.339c0-3.762,0-370.62,0-377.275C459.582,14.98,452.612,8.01,444.015,8.01z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDCDC7"
    },
    d: "M127.051,489.624V23.577c0-8.598,6.969-15.567,15.567-15.567h-20.415 c-8.597,0-15.566,6.969-15.566,15.567v466.047c0,8.598,6.969,15.567,15.566,15.567h20.415 C134.02,505.191,127.051,498.221,127.051,489.624z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8BF00"
    },
    d: "M353.931,107.32H230.98V75.342c0-3.498,2.836-6.333,6.333-6.333h110.125 c3.586,0,6.492,2.907,6.492,6.492v31.819H353.931z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8BF00"
    },
    cx: 201.212,
    cy: 201.242,
    r: 22.708
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8BF00"
    },
    cx: 331.22,
    cy: 201.242,
    r: 22.708
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFA603"
    },
    d: "M257.315,69.008h-20.001c-3.498,0-6.333,2.836-6.333,6.333v31.977h20.001V75.342 C250.981,71.844,253.817,69.008,257.315,69.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFA603"
    },
    d: "M198.503,201.242c0-8.952,5.181-16.691,12.708-20.389c-3.018-1.483-6.411-2.319-10.001-2.319 c-12.542,0-22.708,10.167-22.708,22.708c0,12.542,10.167,22.708,22.708,22.708c3.589,0,6.982-0.836,10.001-2.319 C203.685,217.933,198.503,210.195,198.503,201.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFA603"
    },
    d: "M328.516,201.242c0-8.952,5.181-16.691,12.708-20.389c-3.018-1.483-6.411-2.319-10.001-2.319 c-12.542,0-22.708,10.167-22.708,22.708c0,12.542,10.167,22.708,22.708,22.708c3.589,0,6.982-0.836,10.001-2.319 C333.697,217.933,328.516,210.195,328.516,201.242z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDCDC7"
    },
    d: "M459.582,400.852h-88.772c-8.598,0-15.567,6.969-15.567,15.567v88.772L459.582,400.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9BCB8"
    },
    d: "M375.245,416.418c0-8.598,6.969-15.567,15.567-15.567H370.81c-8.598,0-15.567,6.969-15.567,15.567 v88.772l20.001-20.001V416.418z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.807dd646.svg";
export { ForwardRef as ReactComponent };